import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { take, tap, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import * as fromAuth from '../../auth/reducers/auth.reducer';
import { AuthActions } from '../actions';

export const authGuard: CanActivateFn = () => {
  const store = inject(Store);
  return store.select(fromAuth.selectLoggedIn).pipe(
    tap((authed) => {
      if (!authed) {
        store.dispatch(AuthActions.loginRedirect());
      }
    }),
    take(1),
  );
};

export const loginGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(fromAuth.selectLoggedIn).pipe(
    map((isLoggedIn) => {
      if (isLoggedIn) {
        return router.parseUrl('/data-management');
      }
      return true;
    }),
    take(1),
  );
};

export const adminGuard: CanActivateFn = () => {
  const store = inject(Store);

  return store.select(fromAuth.selectUserInfo).pipe(
    map((userInfo) => {
      if (!userInfo?.isAdmin) {
        return false;
      }
      return true;
    }),
  );
};
